window.app = window.app || {};
let tools = {};
window.app.tools = tools;

tools.plural = function (number, word1, word4, word5) {
    if (number % 100 == 11 || number % 100 == 12 || number % 100 == 13 || number % 100 == 14) return word5;
    if (number % 10 == 1) return word1;
    if (number % 10 == 2 || number % 10 == 3 || number % 10 == 4) return word4;
    return word5;
};

tools.getPageWidth = function () {
    return document.documentElement.clientWidth || document.body.clientWidth;
};

tools.getPageHeight = function () {
    return (document.documentElement.clientHeight || document.body.clientHeight);
};

tools.screen = {
    types: {
        xxxs: 1,
        xxs: 2,
        xs: 3,
        sm: 4,
        md: 5,
        lg: 6
    },

    getType: function () {
        var width = tools.getPageWidth();

        switch (true) {
            case width <= 320:
                return tools.screen.types.xxxs;
                break;

            case width <= 480:
                return tools.screen.types.xxs;
                break;

            case width <= 768:
                return tools.screen.types.xs;
                break;

            case width <= 992:
                return tools.screen.types.sm;
                break;

            case width <= 1200:
                return tools.screen.types.md;
                break;

            case width > 1200:
                return tools.screen.types.lg;
                break;
        }
    },

    is: function (condition) {
        var width = tools.screen.getType();
        var comparison = condition.substr(0, 2);

        if (['<=', '>='].indexOf(comparison) !== -1) {
            condition = condition.substr(2);
        } else {
            comparison = comparison.substr(0, 1);

            if (['<', '>'].indexOf(comparison) !== -1) {
                condition = condition.substr(1);
            }
        }

        switch (comparison) {
            case '<':
                return width < tools.screen.types[condition];
                break;

            case '<=':
                return width <= tools.screen.types[condition];
                break;

            case '>':
                return width > tools.screen.types[condition];
                break;

            case '>=':
                return width >= tools.screen.types[condition];
                break;

            default:
                return width == tools.screen.types[condition];
                break;
        }
    }
};

export const checkBitrixResponse = (response) => {
    if (response.status === 'success') {
        return true;
    }

    if (response.errors) {
        response.errors.map(error => {
            console.error(error.message);
        });
    }

    console.info('response', response);

    if (response.errors) {
        let errorText;

        if (response.errors.length === 2 && response.errors[0].message.indexOf('[Exception]') !== -1) {
            // If bitrix in debug mode and an exception happens, first error will be that exception with backtrace
            // and second one is user-friendly message of this exception
            errorText = response.errors[1].message;
        } else {
            errorText = response.errors.map(item => item.message).join("\n");
        }

        alert('Произошла ошибка, обновите страницу и попробуйте ещё раз.\n' + errorText);
    } else {
        alert('Произошла ошибка, обновите страницу и попробуйте ещё раз');
    }

    return false;
};

export default tools;
